import React from 'react'
import styled from 'styled-components'
import { breakpoint } from '../../shared/theme'

const Wrapper = styled.div`
	position: relative;
	z-index: 10;
	padding-top: 48px;

	> *:last-child {
		padding-bottom: 30px;
	}

	@media ${breakpoint('tablet')} {
		padding-top: 136px;

		&:last-child {
			padding-bottom: 80px;
		}
	}

	p,
	ul,
	ol
	{
		font-size: 14px;

		@media ${breakpoint('mobile')} {
			font-size: 18px;
		}

		@media ${breakpoint('desktop')} {
			font-size: 22px;
		}
	}
`

const PostContentWrap = ({ children }) => {
	return <Wrapper>{children}</Wrapper>
}

export default PostContentWrap
